import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  Typography,
} from '@mui/material';
import React from 'react';

interface SingleSelectProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  label: string;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
}

export const SingleSelect: React.FC<SingleSelectProps> = ({
  options,
  value,
  onChange,
  label,
  helperText,
  placeholder,
  disabled = false,
  required = false,
}) => {
  const safeValue = value ?? '';

  return (
    <FormControl fullWidth margin="dense" required={required}>
      <InputLabel id={`${label.toLowerCase().replace(/\s+/g, '-')}-label`}>
        {label}
      </InputLabel>
      <MuiSelect
        labelId={`${label.toLowerCase().replace(/\s+/g, '-')}-label`}
        id={`${label.toLowerCase().replace(/\s+/g, '-')}-select`}
        value={safeValue}
        label={label}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      >
        {options.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {helperText && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, ml: 1.5 }}
        >
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
};

